import { render, staticRenderFns } from "./PatientDeviceDeleteModal.vue?vue&type=template&id=2fc77554&scoped=true"
import script from "./PatientDeviceDeleteModal.vue?vue&type=script&lang=js"
export * from "./PatientDeviceDeleteModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fc77554",
  null
  
)

export default component.exports